import React, { useEffect, useRef, useState } from 'react';
import FlatList from '@/components/FlatList';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import {
  filtersCounter,
  getFilteredItemsOptions,
  resetFilterItems,
  saveFilteredOptions,
  setMB5SortAndFilterConfig,
} from '../../../../../../redux/actions';
import { getFilteredOptionsProducts } from '../../../../../../utils/getFilteredOptionProducts';
// import LoaderIcon from '@/components/Common/LoaderIcon';
import { FILTER_COUNTER_OPTIONS, SORTING_TYPE } from '@/utils/constants';
import { useSSRSelector } from '@/redux/ssrStore';
import { useWidgetDndContextData } from '@/context/WidgetDndContext';
import { GlobalCfeLoader } from '@/components/WidgetMaker/WidgetDnD/GlobalCfeLoader';
import { ProductListWrapper } from 'src/components/DesignSystem/Widgets2.0/ProductListWrapper';

const TYPE_TAG = 3;

function SortAndFilteredItems() {
  const {
    widgetContextState: { globalStyle },
  } = useWidgetDndContextData();
  const router = useRouter();
  const dispatch = useDispatch();

  const [isFullItemsLoaded, setIsFullItemsLoaded] = useState(false);
  const [initialFilter, setInitialFilter] = useState([]);

  const loader = useRef(false);
  const initialPlpCall = useRef(false);

  const { state } = useSelector((state: any) => {
    const catalogData = state.catalogReducer;
    return {
      state: catalogData.mb5PaginationData.sortAndFilterConfig,
    };
  });

  const { filteredItems, filterAppliedCounter, sortType, filteredOptions } = useSelector(
    (state: any) => ({
      filteredItems: state.catalogReducer.filteredItems,
      filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
      sortType: state.catalogReducer.sortType,
      filteredOptions: state.catalogReducer.filteredOptions,
    })
  );

  const { storeData, categories, productTags } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
    categories: state.catalogReducer?.categories,
    productTags: state.catalogReducer?.productTags,
  }));

  useEffect(() => {
    let pNo = state.pageNo;
    /** if it is plp page plpinitfiltercall will call api with page no 1 */
    if (
      router?.query?.cid !== undefined &&
      !sortType &&
      filterAppliedCounter <= 1 &&
      !(parseInt(router?.query?.cid as string) === -1)
    ) {
      pNo = [0, 1];
    } else {
      pNo = [0];
    }

    loader.current = false;
    dispatch(resetFilterItems());
    dispatch(setMB5SortAndFilterConfig({ ...state, pageNo: pNo, isNext: true }));
  }, [filterAppliedCounter, sortType]);

  useEffect(() => {
    initialPlpCall.current = false;
    plpInitFilterCall();
  }, [router?.query?.cid, categories, productTags]);

  function plpInitFilterCall() {
    if (router?.query?.cid) {
      const selectedCategory = categories.find(
        (categoryItem) => categoryItem?.id == router?.query?.cid
      );
      if (selectedCategory) {
        const categoryFilterObject = {};
        const categorySubFilter = [];
        const subFilter = {};
        subFilter['id'] = selectedCategory?.id;
        subFilter['name'] = selectedCategory?.name;
        categorySubFilter.push(subFilter);
        categoryFilterObject['sub_filters'] = categorySubFilter;
        categoryFilterObject['name'] = 'Categories';
        categoryFilterObject['type'] = 2;
        dispatch(saveFilteredOptions([categoryFilterObject]));
        setInitialFilter([categoryFilterObject]);
        plpFilterCall(categoryFilterObject, SORTING_TYPE.CATEGORIES);
      }
      const selectedTag = productTags.find(
        (tagItem) => tagItem?.id == router?.query?.cid
      );
      if (selectedTag) {
        const tagFilterObject = {};
        const tagSubFilter = [];
        const subFilter = {};
        subFilter['id'] = selectedTag?.id;
        subFilter['name'] = selectedTag?.name;
        tagSubFilter.push(subFilter);
        tagFilterObject['sub_filters'] = tagSubFilter;
        tagFilterObject['name'] = 'Tags';
        tagFilterObject['type'] = 3;
        dispatch(saveFilteredOptions([tagFilterObject]));
        setInitialFilter([tagFilterObject]);
        plpFilterCall(tagFilterObject, SORTING_TYPE.CATEGORIES);
      }
    }
  }

  async function loadMoreItems() {
    const pNo = state.pageNo;
    let isNextPage = state.isNext;
    const currentPageNo = pNo[pNo?.length - 1] + 1;
    if (!loader.current && isNextPage && !initialPlpCall.current) {
      loader.current = true;
      const { status, is_next_page } = await getFilteredOptionsProducts(
        getSelectedFilters(),
        currentPageNo
      );
      if (status) {
        pNo.push(currentPageNo);
        isNextPage = is_next_page;
        if (!is_next_page) {
          setIsFullItemsLoaded(true);
        }
      }
      loader.current = false;
    }
    dispatch(setMB5SortAndFilterConfig({ ...state, pageNo: pNo, isNext: isNextPage }));
  }

  function getSelectedFilters() {
    /** add previous filteroption of collection and category and PLP page */
    let tempFiltersArray =
      router?.query?.cid !== undefined || router?.query?.collectionId !== undefined
        ? [...initialFilter]
        : [];
    if (initialFilter?.[0]?.type === TYPE_TAG && router?.query?.cid) {
      tempFiltersArray = [];
    }
    !!filteredOptions?.length &&
      filteredOptions.forEach((filterItem) => {
        const tempFilterObject = {};
        const tempSubFilterArray = [];
        !!filterItem.sub_filters?.length &&
          filterItem.sub_filters.forEach((subFilterItem) => {
            const tempSubFilters = {};
            if (subFilterItem?.is_selected) {
              tempSubFilters['id'] = subFilterItem?.id;
              tempSubFilters['name'] = subFilterItem?.name;
              tempSubFilters['colour_code'] = subFilterItem?.colour_code;
              tempSubFilterArray.push(tempSubFilters);
            }
          });
        if (tempSubFilterArray?.length) {
          tempFilterObject['name'] = filterItem?.name;
          tempFilterObject['type'] = filterItem?.type;
          tempFilterObject['sub_filters'] = tempSubFilterArray;
          tempFiltersArray.push(tempFilterObject);
        }
      });
    return tempFiltersArray;
  }

  function returnFilterItemsData() {
    return filteredItems;
  }

  function changeinitialPlpCallToFalse(status, isNextPage) {
    if (status) {
      initialPlpCall.current = false;
      dispatch(setMB5SortAndFilterConfig({ ...state, isNext: isNextPage }));
    }
  }

  function plpFilterCall(filterObject, sortType) {
    const payload = {
      store_id: storeData?.store_id,
      page_no: 1,
      sorting_type: sortType,
      filters: [filterObject],
    };
    initialPlpCall.current = true;
    dispatch(getFilteredItemsOptions(payload, changeinitialPlpCallToFalse));
    dispatch(filtersCounter(FILTER_COUNTER_OPTIONS.INC));
  }

  return (
    <div className="SortAndFilteredItemsMid5">
      <FlatList
        isLoaderVisible={false}
        isNext={true}
        onScrollEnd={() => loadMoreItems()}
        // add LoaderComponent for loading sections
        renderInsideFragment
        renderList={() => {
          return (
            <ProductListWrapper
              productList={returnFilterItemsData()}
              oldCardConfigs={{
                showButton: true,
                noTagsReadState: 'fromLength',
              }}
            />
          );
        }}
      />
      {loader.current && state.isNext && !isFullItemsLoaded && (
        <div className="flex justify-center mt4 relative">
          <GlobalCfeLoader
            type={globalStyle?.appLoader?.loaderId || 'ellipsis'}
            color={globalStyle?.appLoader?.color}
          />
          {/* <LoaderIcon style={{ transform: 'translateX(-50%)' }} /> */}
        </div>
      )}
    </div>
  );
}

export default SortAndFilteredItems;
